import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const legacyProjectReleasesRoute = {
	name: ROUTE_NAMES.LEGACY_PROJECT_RELEASES,
	path: '/projects/:projectKey/versions/:id?',
};
